// extracted by mini-css-extract-plugin
export default {"base":"vp_MZsZE","inner":"vp_q4tuB","text":"vp_bVD0r","switch":"vp_BiZyc","close":"vp_Pw8hg"};